const Files = () => {
  return <h2>Files</h2>;
};
export default Files;
